import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import FeatureWrapper from '../FeatureWrapper'
import { Link } from 'react-router-dom'

const getVoltage = SkuByType => {
  const current = SkuByType.filter(x => x.currentSku === true).length > 0
  const _COR = SkuByType.filter(x => x.currentSku === true)[0].COR

  const listMap = current
    ? SkuByType.filter(x => x.COR === _COR)
    : SkuByType.filter(x => x.VOLTAGEM !== undefined)
  return listMap.sort((a, b) => {
    var nameA = a.VOLTAGEM && a.VOLTAGEM.toLowerCase()
    var nameB = b.VOLTAGEM && b.VOLTAGEM.toLowerCase()
    if (nameA < nameB) return -1
    if (nameA > nameB) return 1
    return 0
  })
}

const VoltageFeature = ({ SkuByType }) => {
  const [currentVoltage, setCurrentVoltage] = useState('')

  useEffect(() => {
    const voltage = getVoltage(SkuByType).filter(item => item.currentSku === true)
    setCurrentVoltage(voltage[0].VOLTAGEM)
  }, [window.location])

  return (
    <Fragment>
      <p className='txt-body txt-font-body e'>Voltagem: <strong className='Xbold'>{currentVoltage}</strong></p>
      <FeatureWrapper>
        {getVoltage(SkuByType).map(size => {
          return size.VOLTAGEM && (
            <Link
              to={`/products/${size.sku}`}
              className={`voltage-link ${size.currentSku ? 'current-voltage' : ''}`}
              key={size.sku}
              aria-label={`${size.currentSku ? '(Selecionado) ' : ''}${size.VOLTAGEM.split('Volts').join('V')}`}
            >
              <strong className={`${size.currentSku ? 'current-voltage-volts' : 'voltage-volts'}`}>
                <span aria-hidden='true'>{`${size.VOLTAGEM.split('Volts').join('V')}`}</span>
              </strong>
            </Link>
          )
        })}
      </FeatureWrapper>
    </Fragment>
  )
}

VoltageFeature.propTypes = {
  SkuByType: PropTypes.array
}

export default VoltageFeature



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Feature/FeatureContainer/VoltageFeature.js